export const QUEUES_DATA = 'QUEUES_DATA';

export const ADD_QUEUES_DATA = 'ADD_QUEUES_DATA';

export const SET_QUEUE_NAME = 'SET_QUEUE_NAME';
export const QUEUES_LENGTH = 'QUEUES_LENGTH';
export const GET_DOCUMENTTYPE_FOR_QUEUE = 'GET_DOCUMENTTYPE_FOR_QUEUE';
export const HIDE_CHECKBOXES = 'HIDE_CHECKBOXES';
